import React from "react";
import BarChart from "./Charts/BarChart";
import LineChart from "./Charts/LineChart";
import OrderCard from "./Cards/OrderCard";
import Last30Days from "./Cards/Last30Days";
import AdminsCard from "./Cards/AdminsCard";
import TodoList from "./Cards/TodoList";

function Dashboard() {
  const data = [10, 15, 20, 75, 30];
  const shipped = 40; // Example data for shipped orders
  const delivered = 30; // Example data for delivered orders
  const processing = 20; // Example data for processing orders
  return (
    <div className="mt-24 ml-0 lg:mt-[50px] lg:ml-[200px] lg:pl-8 pt-6 lg:pt-10  p-4 bg-gray-50 flex flex-col md:flex-wrap lg:flex-row gap-10 h-full">
      <div className="flex gap-8 flex-col lg:flex-auto ">
        <div className="p-6 bg-white border rounded-lg shadow-md shadow-gray-200 max-w-[400px] lg:min-h-[260px]">
          <h1 className="text-2xl font-bold mb-4 text-gray-700">
            Orders Summary
          </h1>
          <OrderCard
            shipped={shipped}
            delivered={delivered}
            processing={processing}
          />
        </div>
        <div className="p-6 bg-white border rounded-lg shadow-md shadow-gray-200 max-w-[400px] lg:min-h-[260px]">
          <h1 className="text-2xl font-bold mb-4 text-gray-700">Admins</h1>

          <AdminsCard />
        </div>
      </div>
      <div className="p-6 max-w-[400px] bg-white border rounded-lg shadow-md shadow-gray-200 lg:min-w-[600px] lg:max-h-[550px]">
        <h1 className="text-2xl font-bold mb-4 text-gray-700">To-do List</h1>
        <TodoList />
      </div>
      <div className="p-6 max-w-[400px]  bg-white border rounded-lg shadow-md shadow-gray-200 lg:min-w-[600px] lg:max-h-[550px]">
        <h1 className="text-2xl font-bold mb-4 text-gray-700">Last 30 Days</h1>
        <Last30Days />
      </div>
    </div>
  );
}

export default Dashboard;
